<!-- 品宣首页 -->
<template>
  <div class='brandPublicity page'>
    <v-header :headTitle='headTitle' :isBack='true' v-if="false"></v-header>
    <div class="container">
      <!--  @click='jumoTo("ourStory")' -->
      <!-- 广告区域 -->
      <van-swipe class="banner_swipe" indicator-color="#1C91FF" :autoplay="3000">
        <van-swipe-item>
          <div class="banner banner_ai_weapon" @click="jumpTo('/detail/myAIGkWeapon')">
            <div class="df-between logo_category_bar">
               <img src="../../assets/images/home/gk_logo.png" class="gk-logo" />
              <div @click="jumpTo('/catalogue')">
                <img id="catalogue" src="../../assets/images/home/i-catalogue.png" class="catalogue"  v-if="true"  />
              </div>
            </div>
          </div>
        </van-swipe-item>
        <van-swipe-item>
          <div class="banner banner_story" id="banner" >
            <div class="df-between logo_category_bar">
               <img src="../../assets/images/home/gk_logo.png" class="gk-logo" />
              <div @click="jumpTo('/catalogue')">
                <img id="catalogue" src="../../assets/images/home/i-catalogue.png" class="catalogue"  v-if="true"  />
              </div>
            </div>
            <div class="box_outer">
              <div class="box_inner">
                <div class="row row_one">
                  她说：需要一点情怀才能做好感控</br>
                  他说：感控需要多一点爱
                </div>
                <div class="row row_two">
                  5年前，我们心怀“真挚和美好”</br>
                  探索全新的感染防控过程管理模式</br>
                  一起共建了我们每个人的“感控工作间”
                </div>
                <div class="row row_three">
                  今天，我们的客户遍布全国31个省行政区域</br>
                  我们为客户实现： “多部门多学科主动参与的</br>
                  全员感控模式”。
                </div>
                <div class="our_story_btn" @click="goMyStory">
                  我们的故事 
                  <img src="../../assets/images/home/right-arrow.png" @click="goCatalogue()"  />
                </div>
              </div>
            </div>
          </div>
        </van-swipe-item>
      </van-swipe>
      <div class="content_swrap">
        <!-- 院内, 区域tab -->
        <div class="gk_table">
          <van-tabs color='#1C91FF' title-active-color="#0F82EE" v-model="tabActive" @change="changeMainTab">
            <van-tab title="院内感控">
              <!-- 云平台服务 -->
              <div class="cloud_service">
                <div class="title">一站式医院感染防护云平台服务</div>
                <div class="advance">
                  <div class="advance_item">
                    <img src="../../assets/images/home/i-right.png" />
                    <div class="name">实现督导无纸化</div>
                  </div>
                  <div class="advance_item">
                    <img src="../../assets/images/home/i-right.png" />
                    <div class="name">自动生成服务报告</div>
                  </div>
                  <div class="advance_item">
                    <img src="../../assets/images/home/i-right.png" />
                    <div class="name">多科室在线协同</div>
                  </div>
                  <div class="advance_item">
                    <img src="../../assets/images/home/i-right.png" />
                    <div class="name">信息安全保驾护航</div>
                  </div>
                </div>
                <div class="reward_btn" @click="goApplyUse('hospital')">
                  领取15天免费试用权限
                </div>
              </div>
              <!-- 注册用户, 签约医院数量 -->
              <div class="statistics df-center statistics_blue">
                <div class="statistics_item flex-1 df-center flex-column">
                  <div class="count">340万+</div>
                  <div class="description">注册专业用户</div>
                </div>
                <div class="divider" style="width: 1px;height: 45px;background: #c4deff;opacity: 0.5;border-radius: 1px;"></div>
                <div class="statistics_item flex-1 df-center flex-column">
                  <div class="count">3000+</div>
                  <div class="description">健康使用医院</div>
                </div>
                <!-- <div class="statistics_item"></div> -->
              </div>
              <!-- 产品功能 使用场景 角色收益 用户之声 tab -->
              <van-tabs v-model="serviceTabActive" scrollspy sticky color='#1C91FF' title-active-color="#0F82EE" class="service_list">
                <div class="div" style="border-bottom: 1px solid #eee;"></div>
                <van-tab title="产品功能" class="product_fuction">
                  <!-- 产品功能轮播 -->
<!--                  autoplay="3000"-->
               <!--   <div class="product_x_scroll" @scroll="handleProductScroll">
                    <div class="product_scroll_swap df-item-center" >
                      <div class="product_scroll_item" v-for="(item, index) in productionSwipeList"  :key="index" ref="product_scroll_item">
                          <div class="p_swipe_item df-item-center" v-for="(item2,index2) in item.list" :key="index2">
                            <img :src="item2.img" class="icon" />
                            <div class="content_text">
                              <div class="title">{{item2.mainTitle}}</div>
                              <div class="description">{{item2.subTitle}}</div>
                            </div>
                          </div>
                      </div>
                      <div class="product_scroll_holder"></div>
                    </div>
                  </div> -->
                 <!-- <div class="dot_list df-center">
                    <div class="dot" v-for="(item,index) in this.productionSwipeList" :key="index" :class="{'active':index === areaScenenSwipeIndex}"></div>
                  </div> -->
                 <van-swipe   autoplay="3000">
                   <van-swipe-item v-for="(item, index) in productionSwipeList" :key="index">
                     <div class="p_swipe_item df-item-center" v-for="(item2,index2) in item.list" :key="index2">
                       <img :src="item2.img" class="icon" />
                       <div class="content_text">
                         <div class="title">{{item2.mainTitle}}</div>
                         <div class="description" style="padding-right: 10px;">{{item2.subTitle}}</div>
                       </div>
                     </div>
                   </van-swipe-item>
                 </van-swipe>
                </van-tab>
                <van-tab title="使用场景" class="useScene">
                  <div class="scene_title">
                    场景革新 | 感控工作间使用场景举例
                  </div>
                  <div class="scene_scroll" ref="scene_scroll">
                    <!-- :style="{'width':hospitalUseSceneList.length * 375 + 'px'}" -->
                    <ul class="content_scoll"  >
                      <li v-for="(item,index) in hospitalUseSceneList" :key="index" @click="goScenesDetail(item)">
                        <div class="scene_title">
                          <div class="main_title">{{item.sceneHeadline}}</div>
                          <div class="sub_title">{{item.sceneSubtitle}}</div>
                        </div>
                        <div class="scene_body">
                          <div class="scene_item df-item-center" v-for="(item2,index2) in item.sceneSketchList"
                          :key="index2">
                            <div class="dot"></div>
                            <div class="desc">{{item2}}</div>
                          </div>
<!--                          <div class="scene_item df-item-center">-->
<!--                            <div class="dot" style="background: #FFFFFF;"></div>-->
<!--                            <div class="desc">……</div>-->
<!--                          </div>-->
                        </div>
                      </li>
                      <li class="holder_li">

                      </li>
                    </ul>
                  </div>
                  <div class="more_scene df-center" @click="goMoreScenes">
                    <img src="../../assets/images/home/i-moreScene.png" class="scene_icon" />
                    <div class="tips">更多使用场景，点击查看</div>
                  </div>
                </van-tab>
                <van-tab title="角色收益" class="roles">
                  <div class="roles_income">
                    <div class="roles_title">
                      全员感控 | 多部门多学科在线协同参与
                    </div>
                    <div class="roles_box df-between">
                      <div class="roles_item df-column" v-for="(item,index) in rolesList" :key="index" @click="chooseRole(index)">
                        <img :src="item.rolePic" alt="">
                        <div class="role_name">{{item.roleName}}</div>
                      </div>
                    </div>
                    <div class="roles_btn df-center" @click="chooseRole(0)">点击图片可了解角色收益</div>
                  </div>
                  <!-- 自动报告 -->
                  <div class="auto_report">
                    <div class="report_title">
                      自动生成报告示例 | 助力摆脱繁琐统计
                    </div>
                    <div class="report_item df-item-center" v-for="(item,index) in hospitalReport" @click="goReportDetail(item,index)" :key="index">
                      <img src="../../assets/images/home/i-report.png" alt="" class="i_report">
                      <div class="report_item_title">
                        {{item.title}}
                      </div>
                      <img src="../../assets/images/home/i-right-arrow-2.png" alt="" class="i_right_arrow">
                    </div>

                    <!-- <div class="report_item df-item-center">
                      <img src="../../assets/images/home/i-report.png" alt="" class="i_report">
                      <div class="report_item_title">
                        样例二：防控措施执行-自查/抽查/暗访-专项报告
                      </div>
                      <img src="../../assets/images/home/i-right-arrow-2.png" alt="" class="i_right_arrow">
                    </div>
                    <div class="report_item df-item-center">
                      <img src="../../assets/images/home/i-report.png" alt="" class="i_report">
                      <div class="report_item_title">
                       样例三：督导本改进-自查-单次报告
                      </div>
                      <img src="../../assets/images/home/i-right-arrow-2.png" alt="" class="i_right_arrow">
                    </div>
                    <div class="report_item df-item-center">
                      <img src="../../assets/images/home/i-report.png" alt="" class="i_report">
                      <div class="report_item_title">
                        样例四：质量改进报告-自查/抽查/暗访/-年度报告
                      </div>
                      <img src="../../assets/images/home/i-right-arrow-2.png" alt="" class="i_right_arrow">
                    </div> -->
                  </div>
                </van-tab>
                <van-tab title="用户之声">
                  <div class="user_voice">
                    <div class="user_title">
                      用户之声
                    </div>
                    <div class="user_sub_title">
                      3000+医疗机构健康使用
                    </div>
                    <div class="hospital_img_box df-between">
                      <img src="../../assets/images/home/i-hospital-1.png" alt="">
                      <img src="../../assets/images/home/i-hospital-4.png" alt="">
                      <img src="../../assets/images/home/i-hospital-3.png" alt="">
                      <img src="../../assets/images/home/i-hospital-7.png" alt="">
                      <img src="../../assets/images/home/i-hospital-2.png" alt="">
                      <img src="../../assets/images/home/i-hospital-6.png" alt="">
                    </div>
                    <div class="user_voice_scroll" ref="user_voice_scroll">
                      <!-- :style="{'width': hospitalCaseList.length * 375+ 'px'}" -->
                      <ul class="content_scoll"  >
<!--                        '${downloadPath}${item.caseBgImage}'
                            ../../assets/images/home/i-user-voiec-hospital.png
-->
                        <li v-for="(item,index) in hospitalCaseList" :key="index" class="px-1"
                        :style="`background-image: url('${downloadPath}${item.caseBgImage}')`"
                         @click="goCaseDetail(item.id,item)">
                            <div class="case_mask" >
                                <div class="main_title ellipsis-1 case_mask_title1">{{item.caseTitle}}</div>
                                <div class="sub_title ellipsis-2">{{item.caseSketch}}</div>
                                <div class="detail_btn df-center"  >
                                  <div>了解详情</div>
                                  <img src="../../assets/images/home/i-right-arrow-3.png" alt="">
                                </div>
                             </div>
                        </li>
                        <li></li>
                      </ul>
                    </div>
                    <div class="more_case df-center" @click="goLookCustmerCase(1)">
                      查看更多案例
                    </div>
                  </div>
                  <div class="info_security">
                    <div class="main_title">
                      信息安全保驾护航
                    </div>
                    <div class="sub_title">
                      取得了由公安部核准颁发的“国家信息系统安全等级保护第三级测评”（非金融银行机构最高认证）
                    </div>
                    <div class="info_security_list df-between">
                      <div class="info_security_item df-column">
                        <img src="../../assets/images/home/i-info-security-2.png" alt="">
                        <div class="name">传输加密（SSL）</div>
                      </div>
                      <div class="info_security_item df-column">
                        <img src="../../assets/images/home/i-info-security-1.png" alt="">
                        <div class="name">三级等级 保护</div>
                      </div>
                      <div class="info_security_item df-column">
                        <img src="../../assets/images/home/i-info-security-3.png" alt="">
                        <div class="name">数据脱敏 加密存储</div>
                      </div>
                    </div>
                  </div>
                </van-tab>
              </van-tabs>
            </van-tab>
            <van-tab title="区域感控">
              <!-- 区域云服务平台 -->
              <div class="area_clould_service">
                <div class="main_title">
                  一站式区域感染防控云平台服务
                </div>
                <div class="sub_title">
                  适用于省、市、区县级质控中心/培训中心、医疗中心、医共体/医联体、医疗集团，用于管理和快速提升区域各级医疗机构、专职院感人员感染管理能力的相关服务
                </div>
                <div class="area_service_tab df-center" style="border: 1px solid #EEEEEE">
                  <div class="tab_item flex-1 df-center" v-for="(item,index) in areaServiceTabData" :key="index" :class="{'tab_item_active': index === areaSeviceTabIndex}"
                    @click="changeAreaServiceTab(index)">{{item.name}}</div>
                </div>
                <div class="area_service_scroll" ref="area_service_scroll" @scroll="handleAreaServiceScroll">
<!--                  `width: ${(areaServiceItemWidth + 15) * 3 }px`-->
                  <ul class="content_scoll">
                    <li v-for="(item,index) in areaServiceBodyData" :key="index" style="border: 1px solid #EEEEEE" ref="areaServiceItem">
                      <div class="scene_title">
                        <div class="main_title ellipsis-1">{{item.mainTitle}}</div>
                        <div class="sub_title_s ellipsis-2">{{item.subTitle}}</div>
                      </div>
                      <div class="scene_body">
                        <div class="scene_item df-item-center" v-for="(item2,index2) in item.list" :key="index2">
                          <div class="dot"></div>
                          <div class="desc ellipsis-1">{{item2}}</div>
                        </div>
                      </div>
                      <div class="get_try_out df-center" @click="goApplyUse('area')">
                        领取15天免费试用权限
                      </div>
                    </li>
                    <li id="area_scroll_last">12</li>
                  </ul>
                </div>
              </div>
              <!-- 区域数量 -->
              <!-- 注册用户, 签约医院数量 -->
              <div class="statistics df-center">
                <div class="statistics_item flex-1 df-center flex-column">
                  <div class="count">10万+</div>
                  <div class="description">监测上报次数</div>
                </div>
                <div class="divider" style="width: 1px;height: 45px;background: #c4deff;opacity: 0.5;border-radius: 1px;"></div>
                <div class="statistics_item flex-1 df-center flex-column">
                  <div class="count">646万+</div>
                  <div class="description">区域培训人数</div>
                </div>
                <!-- <div class="statistics_item"></div> -->
              </div>
              <!-- 使用场景,客户案例tab -->
              <van-tabs v-model="areaSceneSubTabIndex" scrollspy sticky color='#1C91FF' title-active-color="#0F82EE"
                class="area_scene_sub_tab">
                <div class="div" style="border-bottom: 1px solid #eee;"></div>
                <van-tab title="使用场景">
                  <div class="areaUseScene">
                    <div class="area_title">易查智改 | 区域感控服务场景举例</div>
<!--                    autoplay="3000"-->
                    <van-swipe class="area_scene_swipe" indicator-color="#1C91FF"  @change="chagneAreaScenceSwipe" autoplay="3000">
                      <van-swipe-item v-for="(item,index) in areaSceneSwipeData" :key="index" >
                        <div class="swipe_box">
                          <div class="swipe_box_title">
                           {{item.mainTile}}
                          </div>
                          <img src="../../assets/images/home/i-divider.png" alt="" class="divide">
                          <div class="swipe_sub_title"  @click="goDetail(index)">
                            {{item.subTitle}}<span class="detail" style="padding-left: 10px">详情 ></span>
                          </div>
                          <div @click="previewImgList(index)">
                            <img :src="item.img" alt="" class="big_img" >
                          </div>
                        </div>
                      </van-swipe-item>
                    </van-swipe>
                  </div>
                  <!-- 自动报告 -->
                  <div class="auto_report">
                    <div class="report_title">
                      自动生成报告示例 | 助力摆脱繁琐统计
                    </div>
                    <div class="report_item df-item-center" v-for="(item,index) in arealReport"  @click="goReportDetail(item,index)" :key="index">
                      <img src="../../assets/images/home/i-report.png" alt="" class="i_report">
                      <div class="report_item_title">
                       {{item.title}}
                      </div>
                      <img src="../../assets/images/home/i-right-arrow-2.png" alt="" class="i_right_arrow">
                    </div>
                    <!-- <div class="report_item df-item-center">
                      <img src="../../assets/images/home/i-report.png" alt="" class="i_report">
                      <div class="report_item_title">
                        样例二：区域多次考试报告
                      </div>
                      <img src="../../assets/images/home/i-right-arrow-2.png" alt="" class="i_right_arrow">
                    </div>
                    <div class="report_item df-item-center">
                      <img src="../../assets/images/home/i-report.png" alt="" class="i_report">
                      <div class="report_item_title">
                        样例三：区域多次学习报告
                      </div>
                      <img src="../../assets/images/home/i-right-arrow-2.png" alt="" class="i_right_arrow">
                    </div>
                    <div class="report_item df-item-center">
                      <img src="../../assets/images/home/i-report.png" alt="" class="i_report">
                      <div class="report_item_title">
                        样例四：区域日常感染监测评估与数据上报报告（定制）
                      </div>
                      <img src="../../assets/images/home/i-right-arrow-2.png" alt="" class="i_right_arrow">
                    </div> -->
                    <div class="holder"></div>
                  </div>
                </van-tab>
                <van-tab title="客户案例" style="height: 400px;">
                  <div class="user_voice">
                    <div class="user_title">
                      客户案例
                    </div>
                    <div class="user_sub_title">
                      16+质控中心/培训中心的共同选择
                    </div>
                    <div class="user_voice_scroll" ref="area_case_scroll">
                      <!-- :style="{'width':  hospitalCaseList.length * 375 + 'px'}" -->
                      <ul class="content_scoll"  >
                        <li v-for="(item,index) in areaCaseList" :key="index" class="px-1" :style="`background-image: url('${downloadPath}${item.caseBgImage}')`" @click="goCaseDetail(item.id,item)">
                          <div class="case_mask" >
                            <div class=" main_title ellipsis-1 case_mask_title1">{{item.caseTitle}}</div>
                            <div class="sub_title ellipsis-2">{{item.caseSketch}}</div>
                            <div class="detail_btn df-center"  @click="knowCaseDetail">
                              <div>了解详情</div>
                              <img src="../../assets/images/home/i-right-arrow-3.png" alt="">
                            </div>
                          </div>
                        </li>
                        <li></li>
                      </ul>
                    </div>
                    <div class="more_case df-center" @click="goLookCustmerCase(2)">
                      查看更多案例
                    </div>
                  </div>
                </van-tab>
              </van-tabs>
            </van-tab>
          </van-tabs>

        </div>
        <!-- 底部链接区域 -->
        <!-- 关于我们 -->
        <div class="about_us">
          <div class="card card_1 ">
            <div class="title" id="about_title">联系我们</div>
            <div class="body body_pad">
              <div class="card_item" id="about_desc">
                招商合作： <span class="phone" id="about_desc"  @click="relationUs(0)">177-8890-2585</span>
              </div>
              <div class="card_item" id="about_desc">
                体验/购买：<span class="phone" @click="relationUs(1)" id="about_desc">173-5285-9232</span>
              </div>
              <div class="card_item" style="margin-bottom: 0;" id="about_desc">
                购买后使用：<span class="phone"  @click="relationUs(2)" id="about_desc">189-7584-0173</span>
              </div>
            </div>
          </div>
          <div class="card card_2" v-if="true">
            <div class="title"  id="about_title">关于我们</div>
            <div class="body">
              <div class="card_row df-item-center">
                <div class="card_row_item flex-1 card_row_item_pad link_active card_row_item_link" @click="jumpTo('/detail/myStory')" id="about_desc">
                  我们的故事
                </div>
                <div class="card_row_item flex-1 link_active card_row_item_link" @click="jumpTo('/serviceList')" id="about_desc">
                  服务清单及报价
                </div>
              </div>
              <div class="card_row df-item-center">
                <div class="card_row_item flex-1 card_row_item_pad df-center link_active" id="about_desc" @click="goTopLocal('hospital')">
                  院内感控
                  <!-- <img src="../../assets/images/home/i-arrow-down.png" alt=""> -->
                </div>
                <div class="card_row_item flex-1 df-item-center  df-center link_active" id="about_desc" @click="goTopLocal('area')">
                  区域感控
                  <!-- <img src="../../assets/images/home/i-arrow-down.png" alt=""> -->
                </div>
              </div>
            </div>
             <div style="height: 68px;background-color:#f2f2f2;"></div>
          </div>
         
        </div>
      </div>
    </div>

  <!--  分享提示  -->
    <div v-show="isShareTips" @click="isShareTips = false" class="share-mask"></div>
<!--    角色弹框-->
    <van-popup v-model="rolesPopupShow"  round closeable
               close-icon="close" close-icon-position="top-right">
        <div class="popup_box df-item-center df-column">
<!--          <div @click="closeRolesPopup" style="margin-left: auto;transform: translateY(-20px)">-->
<!--            <img src="../../assets/images/home/i-pop-close.png" alt="" class="i-close" >-->
<!--          </div>-->
          <div class="popup_inner">
              <div class="popup_header df-item-center" ref="role_header_scroll">
                <div class="popup_header_content df-item-center" style="width: 2200px">
                  <img :src="index !== popupRoleIndex ? item.roleMinPic : item.rolePic" alt="" v-for="(item,index) in rolesList" :key="index" class="role_pic " :class="{'role_min':index !== popupRoleIndex}"  @click="chooseRoleImg(index)">
                </div>
              </div>
              <div class="popup_title">
                {{rolesList[popupRoleIndex].roleName}}
              </div>
            <div class="popup_body">
              <div class="popup_scroll_container" ref="popup_scroll_container">
                <ul >
                  <li v-for="(item2,index2) in roleDescList[popupRoleIndex].list"
                      :key="index2">
                    <div class="scene_item df-item-center">
                      <div class="dot"></div>
                      <div class="desc">{{item2}}</div>
                    </div>
                  </li>
                </ul>
              </div>

            </div>
          </div>

        </div>
    </van-popup>
<!--    <a href="#banner" v-if="false">-->
      <div class="v-top df-center df-column" @click="goUp" v-show="isBackTopShow">
        <img src="../../assets/images/home/i-top.png" alt="">
        顶部
      </div>
<!--    </a>-->

    <v-footer :height="49">
      <div class="footer-item flex-1 df-center" @click="wxShareTips">
        <img src="../../assets/images/home/i-share.png" alt="">
        推荐同行使用
      </div>
      <div style="width: 1px;height: 30px;background-color: #FFFFFF;opacity: 0.5;"></div>
      <div class="footer-item flex-1 df-center" @click="goConsultApplyUse">
        <img src="../../assets/images/home/i-consult.png" alt="">
        咨询专属顾问
      </div>
    </v-footer>
  </div>
</template>
<script>
import header from "../../components/header/header";
import footer from "../../components/footer/footer";
import BetterScroll from "better-scroll";
import Vue from "vue";

import { mapState, mapMutations } from "vuex";

import { Button, Tab, Tabs, Swipe, SwipeItem, ImagePreview, Popup } from "vant";
import axios from "axios";
Vue.use(Button);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Popup);
export default {
  data() {
    return {
      isShare:true,
      // 院内感控, 区域感控
      tabActive: 0,
      // 产品功能 使用场景 角色收益 用户之声 tab
      serviceTabActive: 0,
      // 场景滚动实例
      sceneScroll: "",
      // 用户之声滚动实例
      userVoiceScroll: "",
      // 区域横向滚动实例
      areaServiceScroll: "",
      // 微信分享提示
      isShareTips: false,
      // 区域客户案例横向滚动
      areaCaseScroll: "",
      // 角色弹框显示
      rolesPopupShow: false,
      // 导航栏显示
      isNavShow: true,
      // 返回顶部显示
      isBackTopShow: false,
      // 区域云服务tab索引
      areaSeviceTabIndex: 0,
      // 弹出层索引
      popupRoleIndex: 0,
      // 角色感控体滚动
      roleBodyScroll: "",
      // 角色横向滚动
      rolesHeaderScroll: "",
      // 角色纵向滚动
      rolesBodyScorll: "",
      // 区域云服务跳过赋值
      areaServiceSkip: false,
      // 区域客户案例,使用场景tab索引
      areaSceneSubTabIndex: 0,
      // 首页产品功能轮播图数据
      productionSwipeList: [
        {
          id: 1,
          list: [
            {
              img: require("../../assets/images/home/i-swipe-7.png"),
              mainTitle: "医院感染管理组织在线",
              subTitle: "搭体系：方便院感专兼职人员在线协同工作",
            },
            {
              img: require("../../assets/images/home/i-swipe-1.png"),
              mainTitle: "工作资料/内容在线",
              subTitle:
                "小蜘蛛：适用于查找感控相关指南、文献等的内容库及学习与交流的平台",
            },
            {
              img: require("../../assets/images/home/i-swipe-2.png"),
              mainTitle: "全员知识培训与测评（考试）在线",
              subTitle:
                "培训间：适合各级医务人员学习、培训、测评、考试",
            },
          ],
        },
        {
          id: 2,
          list: [
            {
              img: require("../../assets/images/home/i-swipe-3.png"),
              mainTitle: "督查改进多人协同在线",
              subTitle: "督改本：适用于SDCA循环和PDCA循环",
            },
            {
              img: require("../../assets/images/home/i-swipe-4.png"),
              mainTitle: "移动智能查检与改进在线",
              subTitle: "智查易：手卫生，环境清洁与消毒，医疗废物等防护和防控措施执行依从移动电子化督查与问题清单，支持手机拍照/查看/备注",
            },
            {
              img: require("../../assets/images/home/i-swipe-5.png"),
              mainTitle: "用品消耗管理在线",
              subTitle: "用品易：支持消耗品领用、期末库存数据采集等",
            },
          ],
        },
        {
          id: 3,
          list: [
            {
              img: require("../../assets/images/home/i-swipe-6.png"),
              mainTitle: "管理报告在线",
              subTitle: "报告易：支持按需选择模版及自定义规则生成管理报告",
            },
            {
              img: require("../../assets/images/home/i-swipe-8.png"),
              mainTitle: "风险评估在线",
              subTitle: "建立标准化风险评估体系，支持风险评估全流程闭环管理",
            },
            {
              img: require("../../assets/images/home/i-swipe-9.png"),
              mainTitle: "问题台账本在线",
              subTitle: "支持按单元、按问题类别、按时间形成线上电子台账本",
            },
          ],
        },
        {
          id: 4,
          list: [
            {
              img: require("../../assets/images/home/i-swipe-10.png"),
              mainTitle: "任务管理",
              subTitle: "支持任务智能创建和分配，可视化任务进度追踪和反馈闭环",
            },
            {
              img: require("../../assets/images/home/i-swipe-11.png"),
              mainTitle: "签到与预约",
              subTitle: "线下培训/会议场景,现场扫码签到与存档",
            },
            {
              img: require("../../assets/images/home/i-swipe-12.png"),
              mainTitle: "感控工作间小程序",
              subTitle: "“督导本小程序”“风险评估小程序”，无需下载安装 APP，支持微信小程序便捷操作",
            },
          ],
        },
      ],
      // 区域云服务tab数据
      areaServiceTabData: [
        {
          name: "智查易",
        },
        {
          name: "培训易",
        },
        {
          name: "监测易",
        },
      ],
      // 设备类型 0 ios 1 安卓
      deviceType: 1,
      // 角色数据
      rolesList: [
        {
          roleName: "机构负责人",
          rolePic: require("../../assets/images/home/i-roles-1.png"),
          roleMinPic: require("../../assets/images/home/i-role-min1.png"),
        },
        {
          roleName: "感控科主任",
          rolePic: require("../../assets/images/home/i-roles-2.png"),
          roleMinPic: require("../../assets/images/home/i-role-min2.png"),
        },
        {
          roleName: "专职感控人员",
          rolePic: require("../../assets/images/home/i-roles-3.png"),
          roleMinPic: require("../../assets/images/home/i-role-min3.png"),
        },
        {
          roleName: "兼职感控人员",
          rolePic: require("../../assets/images/home/i-roles-4.png"),
          roleMinPic: require("../../assets/images/home/i-role-min6.png"),
        },
        {
          roleName: "科室主任",
          rolePic: require("../../assets/images/home/i-roles-5.png"),
          roleMinPic: require("../../assets/images/home/i-role-min5.png"),
        },
        {
          roleName: "护士长",
          rolePic: require("../../assets/images/home/i-roles-6.png"),
          roleMinPic: require("../../assets/images/home/i-role-min4.png"),
        },
      ],
      // 角色描述数据
      roleDescList: [
        {
          roleName: "机构负责人",
          list: [
            "帮助建立全院所有临床科室的院感协同工作平台",
            "帮助院感科等科室提升督查效能，解决纸质督导后统计费时易出错的问题",
            "帮助院感科等科室提升改进协同效能，在线进行统一管理和协同提醒",
            "帮助院感科等科室提升培训及测评效能，在线完成人员培训（可避免聚集风险）及测评",
            "随时监控全院情况，实时过程干预",
          ],
        },
        {
          roleName: "感控科主任",
          list: [
            "任选专家推荐查检模版，便捷创建医院评价体系",
            "也可将医院纸质查检表电子化，同步至相关人员手机",
            "用手机即可进行病区抽查，实时记录且真实可追溯",
            "与临床在线协同完成PDCA，随时可视改进过程",
            "可创建院内督导常见问题管理对策库，帮助临床快速获得正确改进方案",
            "可发起网络培训及测评，方便科室用手机或电脑完成",
            "可在线下发院内培训及测评的结果至相关科室",
            "方便查询下载各类工作所需模版、指南规范等文档",
            "可直接获得报表和报告，无需人工统计",
            "随时监控全院情况，实时过程干预",
          ],
        },
        {
          roleName: "专职感控人员",
          list: [
            "携带手机即可进行所辖科室病区抽查",
            "可选常见问题管理对策，快速获得改进方案并便捷记录",
            "与临床在线协同完成PDCA，随时可视改进过程",
            "可选平台共享课程库及试卷库等，快速完成院内网络培训测评",
            "可获得所辖科室参与院内培训及测评数据，监督改进",
            "方便查询下载各类工作所需模版、指南规范等文档",
            "可直接获得所辖科室报表和报告，无需人工统计",
            "随时监控所辖科室防控措施执行等情况，实时过程干预",
          ],
        },
        {
          roleName: "兼职感控人员",
          list: [
            "携带手机即可进行本科室病区自查及改进评价（复查）",
            "可选常见问题管理对策，快速获得改进方案并便捷记录",
            "与院感科/科室主任/护士长在线协同完成本科室相关问题的PDCA改进",
            "可选院内或平台共享课程库及试卷库等，快速完成科内网络培训",
            "可获得本科室参与院内培训及测评数据，监督改进",
            "方便查询下载各类工作所需模版、指南规范等文档",
            "可直接获得本科室报表和报告，无需人工统计",
            "随时监控所辖科室防控措施执行等情况，实时过程干预",
          ],
        },
        {
          roleName: "科室主任",
          list: [
            "用手机即可随时了解本科室病区自查及改进情况",
            "可在线共享常见问题管理对策，提升科室管理改进水平",
            "可与院感科在线协同完成本科室相关重点问题的PDCA改进",
            "可选院内或平台共享课程库及试卷库等，快速完成科内网络培训",
            "可获得本科室参与院内培训及测评数据，监督改进",
            "方便查询下载各类工作所需模版、指南规范等文档",
            "可直接获得本科室报表和报告，无需人工统计",
            "随时监控所辖科室防控措施执行等情况，实时过程干预",
          ],
        },
        {
          roleName: "护士长",
          list: [
            "携带手机即可进行本科室病区护士自查及改进情况",
            "可在线共享常见问题管理对策，帮助护士改进问题并掌握知识",
            "可与院感科在线协同完成本科室护士相关重点问题的PDCA改进",
            "可选院内或平台共享课程库及试卷库等，快速完成科内网络培训",
            "可获得本科室护士参与院内培训及测评数据，监督改进",
            "方便查询下载各类工作所需模版、指南规范等文档",
            "可直接获得本科室护士相关的报表和报告，无需人工统计",
            "随时监控所辖科室护士防控措施执行等情况，实时过程干预",
          ],
        },
      ],
      // 区域云服务body数据
      areaServiceBodyData: [
        {
          mainTitle: "跨机构远程查检与协同",
          subTitle:
            "智查易，适用于区域专项督查，共享标准，实现区域同质化感染防控",
          list: [
            "统一区域各级院感质量评价标准",
            "实现区域质量第三方抽查电子化查检在线",
            "实现区域质量机构互查电子化查检在线",
            "实现所辖区域机构电子化自查自检并数据共享",
          ],
        },
        {
          mainTitle: "跨机构培训在线化",
          subTitle:
            "培训易，区域知识共享的培训和测评，支持自主上传课件、视频与试卷",
          list: [
            "支持多形式参与，适用电脑或手机在线操作",
            "实现区域培训在线化",
            "实现培训前后测验/常规考试测评在线化",
            "实现现场培训或会议直播等远程培训",
          ],
        },
        {
          mainTitle: "多机构医院感染日常监测与数据上报",
          subTitle:
            "监测易，在所辖区域快速搭建“监测与评估”上报体系，实施疫情防控和医院感染防控的常态管理",
          list: [
            "方便医疗机构用APP进行自查并上报监测数据",
            "包括新冠肺炎常态防控监测评估指标上报",
            "包括常规医院感染监测评估指标上报",
          ],
        },
      ],
      // 院内客户案例列表
      hospitalCaseList: [],
      // 区域客户案例列表
      areaCaseList: [],
      // 智查易改轮播图数据
      areaSceneSwipeData: [
        {
          mainTile: "01 · 多机构医院感染日常监测与数据上报",
          subTitle:
            "建立从应急性超常规防控向常规化防控管理转变的「日常感染监测与数据上报」体系",
          img: require("../../assets/images/home/i-zcy-bg1.png"),
        },
        {
          mainTile: "02 · 多机构远程查检（互查/抽查）",
          subTitle:
            "提供所辖区域的移动端质量巡查功能支撑，专家组利用手机/Pad即可记录抽查结果并…",
          img: require("../../assets/images/home/i-zcy-bg-2.png"),
        },
        {
          mainTile: "03 · 同步标准至所辖区域多机构自查",
          subTitle:
            "提供区域同质化管理的快速普及工具，可通过系统将检查标准同步至各医疗机构自查… ",
          img: require("../../assets/images/home/i-zcy-bg3.png"),
        },
        {
          mainTile: "04 · 多机构培训与测评在线化",
          subTitle:
            "建立以线上培训考核为主并实现「在线报名-学习-测验-发证」闭环管理的便捷专职…",
          img: require("../../assets/images/home/i-zcy-bg-4.png"),
        },
      ],
      // 产品横向滚动条目宽度
      productItemWidth: 0,
      // 区域横向滚动的宽度
      areaServiceItemWidth: 0,
      // 院内使用场景列表
      hospitalUseSceneList: [],
      // 区域场景轮播图索引
      areaScenenSwipeIndex: 0,
      // 记录页面滚动位置
      pageScrollTop: 0,
      // 报告案例
      hospitalReport: [
        {
          title: "样例一：手卫生-多个督导单元-多工具-自查抽查暗访-季度报告",
          url:
            "https://education.gkgzj.com/incontrol-fileserver/file/download/8de057cb-9492-4e15-833b-0d5c4d6a76e8",
          type: 1, // 0 链接  1 pdf
        },
        {
          title: "样例二：督导问题跟踪单-单次报告",
          url:
            "https://education.gkgzj.com/incontrol-fileserver/file/download/8031c3db-9143-48e2-a560-22ac7e84d1cd",
          type: 1, // 0 链接  1 pdf
        },
        {
          title: "样例三：督导改进-多个督导单元-单工具-抽查自查暗访-年度报告",
          url:
            "https://education.gkgzj.com/incontrol-fileserver/file/download/f4d026e0-3944-420e-a93c-3b68cebe50a9",
          type: 1, // 0 链接  1 pdf
        },
        {
          title: "样例四：防控措施查核-多个督导单元-单工具-抽查自查暗访-年度报告",
          url:
            "https://education.gkgzj.com/incontrol-fileserver/file/download/0af8e4c6-ac0f-42f9-8ec3-23681f059921",
          type: 1,
        },
        {
          title: "样例五：全院-多个学习任务-在线培训报告",
          url:
            "https://education.gkgzj.com/incontrol-fileserver/file/download/e109c2e1-f96a-42ab-8929-ca574ec75946",
          type: 1,
        },
        {
          title: "样例六：全院风险评估-风险评估报告",
          url:
            "https://education.gkgzj.com/incontrol-fileserver/file/download/d2270e6a-9c24-4809-9e85-368bf9125f75",
          type: 1,
        },
      ],
      arealReport: [
        {
          title: "样例一：区域质量巡查报告",
          url:
            "https://education.gkgzj.com/incontrol-fileserver/file/download/c8a35458-0109-4f57-b612-8276d34981da",
          type: 1, // 0 链接  1 pdf
        },
        {
          title: "样例二：区域多次考试报告",
          // url: 'https://education.gkgzj.com/incontrol-fileserver/file/download/cfaa0239-d144-45e6-8ada-c05f24b73e09',
          url:
            "https://education.gkgzj.com/incontrol-fileserver/file/download/7057c7af-7994-4386-9a5c-36f016f7c294",
          type: 1, // 0 链接  1 pdf
        },
        {
          title: "样例三：区域多次学习报告",
          // url: 'https://education.gkgzj.com/incontrol-fileserver/file/download/7057c7af-7994-4386-9a5c-36f016f7c294',
          url:
            "https://education.gkgzj.com/incontrol-fileserver/file/download/cfaa0239-d144-45e6-8ada-c05f24b73e09",
          type: 1, // 0 链接  1 pdf
        },
        {
          title: "样例四：区域日常感染监测评估与数据上报报告（定制）",
          url:
            "https://education.gkgzj.com/incontrol-fileserver/file/download/f6475009-28d6-44a0-9565-c339a5607e2c",
          type: 1,
        },
      ],
      // 院内场景
      hospitalScene: [],
      headTitle: "感控工作间",
      productData: [
        {
          text1: "工作资料/内容在线",
          text2:
            "小蜘蛛：适用于查找感控相关指南、文献等的内容库及学习与交流的平台",
          contentType: "1",
          pageUrl: "",
        },
        {
          text1: "全员知识培训与测评（考试）在线",
          text2:
            "培训易，适合各级医务人员感控培训、测评考试，支持自主上传课件、视频与试卷",
          contentType: "2",
          pageUrl: "",
        },
        {
          text1: "督查改进院科协同在线",
          text2: "督改易，适用于SDCA循环和PDCA循环",
          contentType: "3",
          pageUrl: "",
        },
        {
          text1: "电子化查检与改进在线",
          text2: "智查易，适用各专项、专科督查",
          contentType: "4",
          pageUrl: "",
        },
        {
          text1: "用品消耗品管理在线",
          text2: "用品易，支持设定防控消耗品名称类型，领用、期末库存数据采集等",
          contentType: "5",
          pageUrl: "",
        },
        {
          text1: "管理报告在线",
          text2: "支持自定义时间、电子化查检表、督导单元生成管理报告",
          contentType: "6",
          pageUrl: "",
        },
        {
          text1: "任务管理在线",
          text2: "用品易，支持设定防控消耗品名称类型，领用、期末库存数据采集等",
          contentType: "7",
          pageUrl: "",
        },
      ],
      feedbackData: [
        {
          text1: "贵州省铜仁市人民医院",
          text2:
            "邀您速看 贵州省铜仁市人民医院--运用“感控工作间”APP提高手卫生管理 能力心得体会",
        },
        {
          text1: "廊坊市第四人民医院",
          text2: "邀您速看 廊坊市第四人民医院 “掌上感控  移动办公“ 分享",
        },
      ],
      areaSceneDetailsData: [
        {
          title: "多机构医院感染日常监测与数据上报",
          text:
            "提供给各级医疗机构实施疫情防控和医院感染防控的常态管理，建立院内每日自查并上报机制",
          imgUrl: require("../../assets/images/bbb.png"),
          contentType: "1",
        },
        {
          title: "区域质量第三方抽查与机构互查",
          text:
            "提供所辖区域的移动端质量巡查功能支撑，专家组利用手机/Pad即可记录抽查结果并上报",
          imgUrl: require("../../assets/images/bbb.png"),
          contentType: "2",
        },
        {
          title: "同步标准至所辖区域医疗机构开展自查自检并数据共享",
          text:
            "提供区域医院感染管理同质化管理的快速普及和覆盖的工具，可通过系统将检查标准同步至各医疗机构进行自查，并自动汇总及统计自查数据。",
          imgUrl: require("../../assets/images/bbb.png"),
          contentType: "3",
        },
        {
          title: "跨机构培训在线化",
          text: "建立所辖区域内的专业院感课程与知识库，支持线上培训与考核。",
          imgUrl: require("../../assets/images/bbb.png"),
          contentType: "4",
        },
      ],
    };
  },
  components: {
    "v-header": header,
    "v-footer": footer,
  },
  computed: {
    ...mapState({
      downloadPath: (state) => state.downloadPath,
    }),
    // // 院内客户案例滑块长度
    // hospitalCaseContentWidth () {
    //   return this.hospitalCaseList.length * 375
    // },
    // // 区域客户案例滑块长度
    // hospitalCaseContentWidth () {
    //   return this.areaCaseList.length * 375
    // }
  },
  mounted() {
    this.cnzzStat("打开品宣", "打开品宣首页", "品宣首页(First_Page)");
    if (this.$route.query && this.$route.query.type === "area") {
      setTimeout(() => {
        this.tabActive = 1;
      });
    } else {
      setTimeout(() => {
        this.tabActive = 0;
      });
    }
    // 初始化横向滚动
    this.$nextTick(() => {
      this.initScroll();
    });
    // 初始化微信分享
    setTimeout(() => {
      this.wxShareInit();
    },500)
    this.isHideNavBar();
    // 窗口滚动事件
    window.addEventListener("scroll", this.handleScroll);
    // 判断设备
    this.whatDevice();
    // setTimeout(() => {
    //     this.initIndexShare()  // 这种分享方式截取了链接（去除了链接中的参数）
    //   }, 500);
  },
  activated() {
    setTimeout(() => {
      this.wxShareInit();
    },500)
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  created() {
    if (this.$route.query.comFrom == 'luckyDraw' && this.$route.query.mobilePhone) { // 从抽奖页面过来
      this.isShareTips = true
    }
    // 获取客户案例列表
    this.getCustomerCaseList();
    // 获取使用场景列表
    this.getUseSceneList();
    // 局部分享
    // this.wxShareInit()
    // setTimeout(() => {
    //     this.initIndexShare()
    //   }, 500);
  },
  //在页面离开时记录滚动位置
  beforeRouteLeave(to, from, next) {
    this.scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop;
    console.log(this.scrollTop, "走了");
    next();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      console.log('重置分享111');
      // vm.initIndexShare()
      console.log(from, "来的路径");
      console.log(vm.scrollTop, "来了");
      if (from.path !== "/detail/myStory") {
        setTimeout(() => {
          document.documentElement.scrollTop = vm.scrollTop;
          document.body.scrollTop = vm.scrollTop;
        });
      } else {
        setTimeout(() => {
          document.documentElement.scrollTop = 0;
          document.body.scrollTop = 0;
        });
        // setTimeout(() => {
        //     if(to.query && to.query.type==='area') {
        //     vm.serviceTabActive = 1
        //      console.log(vm.serviceTabActive,'tab栏位置.....');
        //   } else {
        //      vm.serviceTabActive = 0
        //       console.log(vm.serviceTabActive,'tab栏位置.....');
        //   }
        // }, 500);
      }
      // document.body.scrollTop = vm.scrollTop;
      // document.documentElement.scrollTop =  vm.scrollTop
    });
  },
  // beforeRouteLeave(to,from,next) {
  //   this.pageScrollTop = document.documentElement.scrollTop || document.body.scrollTop
  //   console.log(this.pageScrollTop,'走了.....');
  //   next()
  // },
  // beforeRouteEnter(to, from, next) {
  //   next(vm => {
  //     console.log(vm.pageScrollTop,'来了');
  //     document.body.scrollTop = vm.pageScrollTop
  //   })
  // },
  methods: {
    // 获取抽奖机会
    updatePrizeChance () {
      let params = {
        data: {
          mobile: this.$route.query.mobilePhone,
          operType: "1" // 1-获取抽奖机会，2-使用抽奖机会，3-抽中奖品，4-核销奖品
        }
      };
      this.$http.editUserActivityRecord(params).then((res) => {
      });
    },
    ...mapMutations(["vModelAccessToken"]),
    // 窗口滚动事件
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 800 && this.isBackTopShow !== true) {
        this.isBackTopShow = true;
      } else if (scrollTop < 800 && this.isBackTopShow !== false) {
        this.isBackTopShow = false;
      }
      // console.log(scrollTop)
    },
    // 去场景详情页
    goScenesDetail(item) {
      this.cnzzStat(
        "手卫生管理在线",
        "点击查看院内感控手卫生管理的使用场景介绍",
        "手卫生场景(HS_HD_Management)"
      );
      this.$router.push({
        path: "/detail/scenesDetail",
        query: {
          id: item.id,
        },
      });
    },
    // 去报告详情页
    goReportDetail(item, index) {
      console.log(index);
      if (this.tabActive === 1) {
        if (index === 0) {
          this.cnzzStat(
            "区域报告样例",
            "点击查看区域的报告样例-质量巡查报告",
            "质量巡查报告(RE_Quality_Supervision_Report)"
          );
        } else if (index === 1) {
          this.cnzzStat(
            "区域报告样例",
            "点击查看区域的报告样例-多次考试报告",
            "多次考试报告(RE_MultiExamination_Report)"
          );
        } else if (index === 2) {
          this.cnzzStat(
            "区域报告样例",
            "点击查看区域的报告样例-多次学习报告",
            "多次学习报告(RE_Multilearning_Report)"
          );
        } else if (index === 3) {
          this.cnzzStat(
            "区域报告样例",
            "点击查看区域的报告样例-监测统计报告",
            "监测统计报告(RE_Monitor_Reportingbook)"
          );
        }
      }

      if (this.tabActive === 0) {
        if (index === 0) {
          this.cnzzStat(
            "院内报告样例",
            "点击查看院内的报告样例-手卫生报告",
            "手卫生报告(HS_HD_Reportingbook)"
          );
        } else if (index === 1) {
          this.cnzzStat(
            "院内报告样例",
            "点击查看院内的报告样例-防控报告",
            "防控报告(HS_Prevention_Supervision_Reportingbook)"
          );
        } else if (index === 2) {
          this.cnzzStat(
            "院内报告样例",
            "点击查看院内的报告样例-改进报告",
            "多次学习报告(HS_Improving_Reportingbook)"
          );
        } else if (index === 3) {
          this.cnzzStat(
            "院内报告样例",
            "点击查看院内的报告样例-培训报告",
            "培训报告(HS_Learning_Reportingbook)"
          );
        } else if (index === 4) {
          this.cnzzStat(
            "院内报告样例",
            "点击查看院内的报告样例-综合年度报告",
            "综合年度报告(HS_Comprehensive Annual_Reportingbook)"
          );
        } else if (index === 5) {
          this.cnzzStat(
            "院内报告样例",
            "点击查看院内的报告样例-手卫生年度报告",
            "手卫生年度报告(HS_HD Annual_Reportingbook)"
          );
        }
      }

      if (item.type === 0) {
        // this.$router.push(item.url)
        // 链接
        window.location.href = item.url + "&sourceFrom=pinxuan";
      } else if (item.type === 1) {
        // window.open(item.url)
        this.$router.push({
          path: "/file/file",
          query: {
            url: item.url,
            title: item.title.split('：')[1]
          },
        });
        // pdf id
      }
      console.log(item);
    },
    // 判断设置
    whatDevice() {
      let ua = navigator.userAgent.toLowerCase();
      //       //Android终端
      //       let isAndroid =ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;
      // 　　   //Ios终端
      //       let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      let isAndroid = /android /.test(ua);
      let isiOS = /iphone/.test(ua);
      if (isAndroid) {
        this.deviceType = 1;
      } else if (isiOS) {
        this.deviceType = 0;
      }
      console.log(ua, "浏览器头....");
      console.log(isAndroid, "是安卓吗....");
      console.log(isiOS, "是ios吗....");
    },
    // 判断是微信浏览器吗
    isWeixinBrowser() {
      return /micromessenger/.test(ua) ? true : false;
    },
    // 返回顶部
    goUp() {
      // console.log('返回顶部....')
      let nowTop =
        document.body.scrollTop || document.documentElement.scrollTop; // 获取当前滚动条位置
      // console.log(nowTop)
      if (nowTop > 0) {
        window.requestAnimationFrame(this.goUp);
        window.scrollTo(0, nowTop - nowTop / 5);
      }
    },
    // 本页面跳转
    goTopLocal(type) {
      if (type === "area") {
        this.tabActive = 1;
        this.goUp();
      } else {
        this.tabActive = 0;
        this.goUp();
      }
    },
    // 申请试用与购买
    goApplyUse(type) {
      // '/applyUse'
      console.log(type);
      if (type === "hospital") {
        this.cnzzStat(
          "手卫生管理在线",
          "在院内感控手卫生管理页面点击免费体验按钮",
          "免费体验(HS_Key_Free_Experience)"
        );
      }
      this.$router.push({
        path: "/applyUse",
        query: {
          type: type,
          buyType: 'try'
        },
      });
    },
    // 咨询专属顾问
    goConsultApplyUse(type) {
      console.log("111");
      // '/applyUse'
      if (this.tabActive === 0) {
        this.cnzzStat(
          "手卫生管理在线",
          "在院内感控手卫生管理页面点击咨询专属顾问按钮",
          "咨询专属顾问(HS_Key_Consult_Service)"
        );
      }
      this.$router.push({
        path: "/applyUse",
        query: {
          type: type,
           buyType: 'question'
        },
      });
    },
    // 打电话
    callPhone(phone = "") {
      this.utils.handleOnTell(phone)
    },
    // 获取微信分享票据
    getWXShare() {
      const params = {
        data: {
          shareUrl: "https%3A%2F%2Fdemo.gkgzj.com%2Fmanager-intf%2F",
        },
      };
      this.$http.getShareTicket(params).then((res) => {
        console.log(res);
      });
    },
    // 微信分享
    wxShareInit () {
      console.log(this.$route.query.comFrom, '999');
      let _this = this 
      let descs = "因为爱, 所以感控";
      let taskName = "快速了解感控工作间";
      console.log("局部分享 首页666");
      this.commom.weiXinReady(3, descs, taskName, "", "", "", () => {
        console.log('分享成功111');
        this.isShare = false;
        console.log(_this.$route.query.comFrom,'_this.$route.query.comFrom');
        if (_this.$route.query.comFrom == 'luckyDraw') {
          // 获取抽奖机会
          this.updatePrizeChance()
          _this.$router.go(-1)
        }
      }, location.href.split('#')[0]);
    },
    // 是否隐藏导航栏
    isHideNavBar() {
      let ua = navigator.userAgent.toLowerCase();
      let isWX = ua.match(/MicroMessenger/i) == "micromessenger";
      console.log(isWX);
      this.isNavShow = !isWX;
    },
    // 选择角色
    chooseRole(index) {
      this.popupRoleIndex = index;
      this.rolesPopupShow = true;
      this.$nextTick(() => {
        this.initScroll();
        if (this.rolesHeaderScroll) {
          this.rolesHeaderScroll.scrollTo(
            -60 * index,
            0,
            300,
            undefined,
            undefined
          );
          // if(index >2 ) {
          //   this.rolesHeaderScroll.scrollTo(-280,0,300,undefined,undefined)
          // }else  {
          //   this.rolesHeaderScroll.scrollTo(-2,0,300,undefined,undefined)
          // }
        }
      });
    },
    // 选择角色
    chooseRoleImg(index) {
      // console.log(index)
      this.popupRoleIndex = index;
      this.$refs["popup_scroll_container"].scrollTop = 0;
    },
    // 去申请试用页面
    // goApplyUse() {
    //   this.$router.push('/applyUse')
    // },
    // 去详情页
    goDetail(index) {
      if (index === 1 || index === 2) {
        if (index === 1) {
          this.cnzzStat(
            "区域使用场景",
            "点击查看多机构远程查检与协同的使用场景介绍",
            "多机构抽查(RE_MultiHospital_Inspection)"
          );
        } else {
          this.cnzzStat(
            "区域使用场景",
            "点击查看同步标准至所辖区域机构进行自查的使用场景介绍",
            "多机构自查(RE_MultiHospital_SelfInspection)"
          );
        }
        this.$router.push("/detail/inspection");
      } else if (index === 3) {
        this.cnzzStat(
          "区域使用场景",
          "点击查看多机构培训与测评的使用场景介绍",
          "培训与测评(RE_MultiHospital_learning)"
        );
        this.$router.push("/detail/studyInline");
      } else {
        this.cnzzStat(
          "区域使用场景",
          "点击查看多机构日常感染管理监测指标上报的使用场景介绍",
          "监测上报(RE_Monitor_Report)"
        );
        this.$router.push("/detail/monitorReport");
      }
      console.log(index, "详情");
    },
    //去更多使用场景页
    goMoreScenes() {
      // this.cnzzStat(
      //   "手卫生管理在线",
      //   "点击查看院内感控手卫生管理的使用场景介绍",
      //   "手卫生场景(HS_HD_Management)"
      // );
      this.$router.push("/list/moreScenes");
      console.log("更多场景");
    },
    //我们的故事
    goMyStory() {
      this.$router.push("/detail/myStory");
      console.log("更多场景");
    },
    goLookCustmerCase(type) {
      // 1 客户案例  2 区域案例
      this.$router.push({
        path: "/list/customerCase",
        query: {
          type: type,
        },
      });
    },
    // 获取登录token
    getAccessToken() {
      const params = {
        grant_type: "client_credentials",
      };
      // 获取token
      this.$http.token(params).then((res) => {
        this.vModelAccessToken(res);
      });
    },
    // 联系我们
    relationUs(index) {
      let phone = ['17788902585','17352859232','18975840173']
      if(index === 0) {
        this.cnzzStat('联系我们', '点击电话联系-招商合作','招商合作(TL_Investment_Cooperation)');
      } else if (index === 1) {
        this.cnzzStat('联系我们', '点击电话联系-体验购买','体验购买(TL_Experience_Buying)');
      } else if (index === 2) {
        this.cnzzStat('联系我们', '点击电话联系-购买后使用','购买后使用(TL_Use_After_Buying)');
      } 
      this.callPhone(phone[index])
    },
    // 获取客户案例列表
    getCustomerCaseList(caseType = "1") {
      const parmas = {
        caseType: caseType, // 1  院内感控 2 区域感控
        state: "1",
        page: "1",
        offset: "10",
        addToHome: "1",
      };
      console.log(parmas);
      this.$http.getCustomerCaseList(parmas).then((res) => {
        console.log(res);
        if (caseType == "1") {
          this.hospitalCaseList = res.data.rows.slice(0, 5);
          // this.$nextTick(() => {
          //   this.userVoiceScroll.refresh()
          // })
        } else if (caseType == "2") {
          this.areaCaseList = res.data.rows.slice(0, 5);
          // this.$nextTick(() => {
          //   this.areaCaseScroll.refresh()
          // })
        }
      });
    },
    // 获取使用场景列表
    getUseSceneList() {
      const params = {
        sceneType: "1",
        state: "1",
        addToHome: "1",
        page: 1,
        offset: "10",
      };
      this.$http.getUseSceneList(params).then((res) => {
        this.hospitalUseSceneList = res.data.rows.slice(0, 5);
        this.hospitalUseSceneList.forEach((v) => {
          v.sceneSketchList = v.sceneSketch.split("</br>");
        });
        // this.$nextTick(() => {
        //   this.sceneScroll.refresh()
        // })
        console.log(this.hospitalUseSceneList, "场景111");
      });
      // this.$http.getUseSceneList(params)
      //   .then(res =>
    },
    // 去目录页
    goCatalogue() {
      console.log(1111);
    },
    jumoTo(pathName, type) {
      console.log(pathName, 111);

      const query = {
        comForm: "1",
      };
      if (
        pathName == "productIntroduce" ||
        pathName == "areaSceneDetailsData"
      ) {
        query.contentType = type;
      }
      this.$router.push({
        name: pathName,
        query: query,
      });
    },
    // 去客户案例详情页面
    goCaseDetail(id, item) {
       if(this.tabActive === 0) {
        this.cnzzStat('客户案例', `点击查看上传的用户案例(${id})`,'院内案例(HS_Customer_Case)');
      } else if (this.tabActive === 1) {
        this.cnzzStat('客户案例', `点击查看上传的区域案例(${id})`,'区域案例(RE_Customer_Case)');
      }
      // return
      console.log(item, "案例详情");
      // 链接
      // if(item.detailType === '1') {
      //   return location.href = item.caseDetail
      // }
      this.$router.push({
        path: "/detail/caseDetail",
        query: {
          id: id,
        },
      });
    },
    // 区域服务tab切换
    changeAreaServiceTab(index) {
      if (
        this.$refs["areaServiceItem"].length > 0 &&
        this.areaServiceItemWidth === 0
      ) {
        this.areaServiceItemWidth = this.$refs[
          "areaServiceItem"
        ][0].scrollWidth;
        // console.log(this.areaServiceItemWidth)
      }
      let scrollLeft = (this.areaServiceItemWidth + 10) * index;
      this.$refs["area_service_scroll"].scrollLeft = scrollLeft;
      // console.log()
      // let diffValue = Math.abs(this.areaSeviceTabIndex - index)
      // this.areaServiceSkip = diffValue === 2
      // this.areaSeviceTabIndex = index
      //  bs.scrollTo(0, -60, 300, undefined, extraTransform)
      //   let step = this.deviceType === 0 ? 375 : 325
      //   console.log(step,'步长.....')
      // this.areaServiceScroll.scrollTo(-step * index,0,300,undefined,undefined)
    },
    // 院内和区域的tab切换发生改变
    changeMainTab(e) {
      console.log(e);
      // this.getWXShare()
      const caseType = e + 1 + ""; // 1 院内 2区域
      this.getCustomerCaseList(caseType);
      this.$nextTick(() => {
        this.initScroll();
      });
    },
    // 客户案例了解详细
    knowCaseDetail() {
      console.log("了解详情...");
    },
    // 微信分享提示
    wxShareTips() {
      if (this.tabActive === 0) {
        this.cnzzStat(
          "手卫生管理在线",
          "在院内感控手卫生管理页面点击推荐同行使用按钮",
          "推荐同行使用(HS_Key_Use_Recommend)"
        );
      }
      this.isShareTips = true;
    },
    // 改变区域轮播图索引
    chagneAreaScenceSwipe(e) {
      this.areaScenenSwipeIndex = e;
    },
    // 关闭弹框
    closeRolesPopup() {
      this.rolesPopupShow = false;
      // console.log('close....')
    },
    // 预览轮播图
    previewImgList(index) {
      console.log(index);
      let previewImgList = this.areaSceneSwipeData.map((v) => v.img);
      ImagePreview({
        images: previewImgList,
        startPosition: index,
        closeable: true,
        closeIconPosition: 'top-right'
      });
      console.log(previewImgList, "轮播图数据");
    },
    jumpTo(path) {
      this.$router.push(path);
    },
    // 处理产品横向滚动
    handleProductScroll(e) {
      if (
        this.$refs["product_scroll_item"].length > 0 &&
        this.productItemWidth === 0
      ) {
        this.productItemWidth = this.$refs[
          "product_scroll_item"
        ][0].scrollWidth;
        console.log(this.productItemWidth);
      }
      let scrollLeft = e.target.scrollLeft;
      if (
        scrollLeft < this.productItemWidth &&
        this.areaScenenSwipeIndex !== 0
      ) {
        this.areaScenenSwipeIndex = 0;
      } else if (
        scrollLeft > this.productItemWidth &&
        scrollLeft < this.productItemWidth * 2 &&
        this.areaScenenSwipeIndex !== 1
      ) {
        this.areaScenenSwipeIndex = 1;
      } else if (
        scrollLeft > this.productItemWidth * 2 &&
        this.areaScenenSwipeIndex !== 2
      ) {
        this.areaScenenSwipeIndex = 2;
      }
      // console.log(e.target.scrollLeft)
    },
    // 处理区域场景横向滚动
    handleAreaServiceScroll(e) {
      if (
        this.$refs["areaServiceItem"].length > 0 &&
        this.areaServiceItemWidth === 0
      ) {
        this.areaServiceItemWidth = this.$refs[
          "areaServiceItem"
        ][0].scrollWidth;
        console.log(this.areaServiceItemWidth);
      }
      let scrollLeft = e.target.scrollLeft;
      if (
        scrollLeft < this.areaServiceItemWidth &&
        this.areaSeviceTabIndex !== 0
      ) {
        this.areaSeviceTabIndex = 0;
      } else if (
        scrollLeft > this.areaServiceItemWidth &&
        scrollLeft < this.areaServiceItemWidth * 2 &&
        this.areaScenenSwipeIndex !== 1
      ) {
        this.areaSeviceTabIndex = 1;
      } else if (
        scrollLeft > this.areaServiceItemWidth * 2 &&
        this.areaScenenSwipeIndex !== 2
      ) {
        this.areaSeviceTabIndex = 2;
      }
      // console.log(e.target.scrollLeft)
    },
    // 初始化横向滚动
    initScroll() {
      // 使用场景横向滚动
      // if (!this.sceneScroll && this.$refs.scene_scroll) {
      //   console.log('scene_scroll')
      //   this.sceneScroll = new BetterScroll(this.$refs.scene_scroll, {
      //     scrollX: true,
      //     eventPassthrough: 'vertical'
      //   })
      // }
      // 用户之声横向滚动
      // if (!this.userVoiceScroll && this.$refs.user_voice_scroll) {
      //   console.log('user_voice_scroll')
      //   this.userVoiceScroll = new BetterScroll(this.$refs.user_voice_scroll, {
      //     scrollX: true,
      //     eventPassthrough: 'vertical'
      //   })
      // }
      // 区域云服务横向滚动
      // if (!this.areaServiceScroll && this.$refs.area_service_scroll && false) {
      //   console.log('area_service_scroll')
      //   this.areaServiceScroll = new BetterScroll(this.$refs.area_service_scroll, {
      //     scrollX: true,
      //     eventPassthrough: 'vertical',
      //     probeType: 3
      //   })
      //   if (this.$refs['areaServiceItem'].length > 0 && this.areaServiceItemWidth === 0) {
      //     this.areaServiceItemWidth = this.$refs['areaServiceItem'][0].scrollWidth
      //   }
      //   this.areaServiceScroll.on('scroll',(e) => {
      //     console.log(e.x)
      //     console.log(this.$refs['areaServiceItem'])
      // if(this.deviceType === 0 ) {
      //   if(e.x > -630 && e.x < -320 && !this.areaServiceSkip && this.areaSeviceTabIndex !== 1) {
      //     this.areaSeviceTabIndex = 1
      //   } else if (e.x < -630 && this.areaSeviceTabIndex !== 2) {
      //     this.areaSeviceTabIndex = 2
      //   } else if (e.x > - 320 && this.areaSeviceTabIndex !== 0) {
      //     this.areaSeviceTabIndex = 0
      //   }
      // } else if (this.deviceType === 1) {
      //   if(e.x > -630 && e.x < -320 && !this.areaServiceSkip && this.areaSeviceTabIndex !== 1) {
      //     this.areaSeviceTabIndex = 1
      //   } else if (e.x < -630 && this.areaSeviceTabIndex !== 2) {
      //     this.areaSeviceTabIndex = 2
      //   } else if (e.x > - 320 && this.areaSeviceTabIndex !== 0) {
      //     this.areaSeviceTabIndex = 0
      //   }
      // }
      //   })
      //   this.areaServiceScroll.on('scrollEnd',(e) => {
      //     this.areaServiceSkip = false
      //     console.log(e,'结束')
      //   })
      // }
      // 区域客户案例
      // if (!this.areaCaseScroll && this.$refs.area_case_scroll) {
      //   console.log('area_case_scroll')
      //   this.areaCaseScroll = new BetterScroll(this.$refs.area_case_scroll, {
      //     scrollX: true,
      //     eventPassthrough: 'vertical'
      //   })
      // }
      // 角色感控头
      if (!this.rolesHeaderScroll && this.$refs.role_header_scroll) {
        console.log("rolesHeaderScroll");
        this.rolesHeaderScroll = new BetterScroll(
          this.$refs.role_header_scroll,
          {
            scrollX: true,
            eventPassthrough: "vertical",
          }
        );
        this.rolesHeaderScroll.scrollTo(-2, 0, 50, undefined, undefined);
        // this.areaSceneSwipeData = this._.cloneDeep(this.areaSceneSwipeData)
      }
    },
  },

  watch: {
    isShare () {
      console.log('变化了变化了11122'); 
    },
    $route(to, from) {
      if (from.path === "/catalogue") {
        if (to.query && to.query.type === "area") {
          setTimeout(() => {
            this.tabActive = 1;
            this.getCustomerCaseList("2");
          });
        } else {
          setTimeout(() => {
            this.tabActive = 0;
          });
        }
      }
      // console.log(to,'routess......');
    },
  },
};
</script>
<style lang='scss' scoped>
.brandPublicity {
  /* padding-top: 50px; */
  .container {
    height: 100%;
    //overflow: auto;
    //padding-bottom: 50px;
    font-size: 14px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    color: #333333;

    /* 广告区域 */
    .banner_swipe {
      max-width: 500px;
      margin: 0 auto;
      /deep/ .van-swipe__indicators{
        bottom: 52px;
      }
    }

    .banner {
      /* width: 375px; */
      position: relative;
      box-sizing: border-box;
      // padding-top: 95px;
      height: 432px;
      /* background-color: pink; */
      background-size: 100% 100%;

      &.banner_story {
        background: url("../../assets/images/home/bg-banner-index.png") no-repeat;
        background-size: 100% 100%;
      }

      &.banner_ai_weapon {
        background: url("../../assets/images/home/bg-banner-aiWeapon.png") no-repeat;
        background-size: 100% 100%;
      }

      .logo_category_bar {
        box-sizing: border-box;
        padding-right: 14px;
        margin-bottom: 51px;
      }

      .gk-logo {
        // position: absolute;
        // z-index: 999;
        // left: 0;
        // top: 0;
        width: 113px;
        height: 43px;
      }

      .catalogue {
        // position: absolute;
        // z-index: 999;
        // top: 12px;
        // right: 16px;
        width: 24px;
        height: 24px;
      }

      .box_outer {
        position: relative;
        /* left: 30px;
          top: 95px; */
        margin: 0 auto;
        width: 315px;
        height: 249px;
        background: rgba(194, 241, 255, 0.21);
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;

        .box_inner {
          display: flex;
          /* justify-content: center; */
          flex-direction: column;
          align-items: center;
          width: 304px;
          height: 238px;
          background: rgba(248, 253, 255, 0.4);
          border-radius: 12px;

          .row {
            opacity: 1;
            font-size: 14px;
            font-family: PingFangSC, PingFangSC-Regular;
            font-weight: 400;
            text-align: center;
            color: #126fd8;
            line-height: 23px;
          }

          .row_one {
            margin-top: 10px;
          }

          .row_two {
            margin: 5px 0;
          }

          .our_story_btn {
            position: absolute;
            bottom: -20px;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 240px;
            height: 50px;
            background: linear-gradient(316deg, #1c91ff 2%, #76b9f0);
            border-radius: 25px;
            box-shadow: 0px 1px 6px 0px rgba(255, 255, 255, 0.5) inset;
            font-size: 18px;
            font-family: PingFangSC, PingFangSC-Medium;
            font-weight: 500;
            color: #ffffff;

            img {
              margin-left: 8px;
              width: 18px;
              height: 18px;
            }
          }
        }
      }
    }

    /* 内容区域 */
    .content_swrap {
      // position和z-index是为了解决ios手机下banner_swipe的van-swipe-item切换时院内感控、区域感控tabs闪动问题
      position: relative;
      z-index: 999;
      .gk_table {
        position: relative;
        z-index: 999;
        margin-top: -42px;
        min-height: 44px;
        border-radius: 20px 20px 0 0;
        background-color: #ffffff;
        overflow: hidden;

        /* 云平台服务 */
        .cloud_service {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          flex-wrap: wrap;

          .title {
            margin-top: 30px;
            margin-bottom: 30px;
            font-size: 18px;
            font-family: SourceHanSansCN, SourceHanSansCN-Bold;
            font-weight: 700;
            text-align: center;
            color: #333333;
            line-height: 20px;
          }

          .advance {
            display: flex;
            flex-wrap: wrap;
            box-sizing: border-box;
            padding: 0 41px;
            justify-content: space-between;

            .advance_item {
              display: flex;
              align-items: center;
              margin-top: 11px;

              img {
                margin-right: 10px;
                width: 14px;
                height: 14px;
              }

              .name {
                font-size: 14px;
                font-family: STYuanti, STYuanti-TC;
                font-weight: TC;
                color: #333333;
                line-height: 20px;
              }
            }
          }

          .reward_btn {
            margin-top: 20px;
            margin-bottom: 31px;
            width: 225px;
            height: 50px;
            text-align: center;
            line-height: 50px;
            opacity: 1;
            background: linear-gradient(131deg, #fc8a55, #f97482 95%);
            border-radius: 25px;
            box-shadow: 0px 1px 5px 0px #fc875c;
            font-size: 16px;
            font-family: STYuanti, STYuanti-SC;
            font-weight: SC;
            color: #ffffff;
          }
        }

        /* 注册用户, 签约医院数量  */
        .statistics {
          height: 88px;
          opacity: 1;
          // background: linear-gradient(180deg, #f5f9ff, #ffffff 98%);
          background: #f5f9ff !important;
          .statistics_item {
            .count {
              font-size: 24px;
              margin-bottom: 5px;
              font-family: PingFangSC, PingFangSC-Semibold;
              font-weight: 600;
              text-align: left;
              color: #1c91ff;
              line-height: 33px;
            }

            .description {
              font-size: 14px;
              font-family: PingFangSC, PingFangSC-Regular;
              font-weight: 400;
              text-align: center;
              color: #666666;
            }
          }
        }

        /*  产品功能 使用场景 角色收益 用户之声 tab */
        .service_list {
          .van-tabs__nav {
            border-bottom: 1px solid #eeeeee !important;
          }

          /* 产品功能 */
          .product_fuction {
            position: relative;
            .product_scroll_holder {
              height: 372px;
              width: 100px;
              padding-left: 50px;
            }
            .dot_list {
              position: absolute;
              left: 50%;
              transform: translateX(-50%);
              bottom: 30px;
              .dot {
                flex-shrink: 0;
                margin-right: 13px;
                width: 10px;
                height: 10px;
                opacity: 1;
                background: #eeeeee;
                border-radius: 50%;
              }
              .active {
                background: #1c91ff;
              }
            }
            .product_x_scroll {
              width: 100%;
              overflow: auto;

              -webkit-overflow-scrolling: touch;

              .product_scroll_swap {
                box-sizing: border-box;
                padding: 10px 0px 10px 12px;
                .product_scroll_item {
                  height: 372px;
                  background-color: #ffffff;
                  box-sizing: border-box;
                  padding-top: 10px;

                  .p_swipe_item {
                    /* width: 375px; */
                    height: 100px;
                    box-sizing: border-box;
                    padding: 16px 0 0 12px;

                    img {
                      width: 60px;
                      height: 60px;
                      flex-shrink: 0;
                      margin-right: 10px;
                    }

                    .content_text {
                      height: 64px;

                      .title {
                        font-size: 15px;
                        margin-bottom: 6px;
                        font-family: PingFangSC, PingFangSC-Medium;
                        font-weight: 500;
                        text-align: left;
                        color: #333333;
                        line-height: 21px;
                      }

                      .description {
                        font-size: 12px;
                        text-align: left;
                        color: #666666;
                        line-height: 17px;
                      }
                    }
                  }
                }
              }
            }
            .van-swipe-item {
              height: 360px;
              background-color: #ffffff;
              box-sizing: border-box;
              padding-top: 10px;

              .p_swipe_item {
                height: 100px;
                box-sizing: border-box;
                padding: 20px 0 0 24px;

                img {
                  width: 60px;
                  height: 60px;
                  flex-shrink: 0;
                  margin-right: 10px;
                }

                .content_text {
                  height: 64px;

                  .title {
                    font-size: 15px;
                    margin-bottom: 6px;
                    font-family: PingFangSC, PingFangSC-Medium;
                    font-weight: 500;
                    text-align: left;
                    color: #333333;
                    line-height: 21px;
                  }

                  .description {
                    font-size: 12px;
                    text-align: left;
                    color: #666666;
                    line-height: 17px;
                  }
                }
              }
            }
          }

          /* 使用场景 */
          .useScene {
            height: 478px;
            background: #f5f9ff;
            box-sizing: border-box;
            padding-top: 30px;

            .scene_title {
              text-align: center;
              font-size: 18px;
              font-family: SourceHanSansCN, SourceHanSansCN-Bold;
              font-weight: 700;
              text-align: center;
              color: #333333;
              line-height: 20px;
            }

            .scene_scroll {
              margin-top: 40px;
              height: 300px;
              /* width: 375px; */
              width: 100%;
              overflow: auto;
              -webkit-overflow-scrolling: touch;
              box-sizing: border-box;
              padding-top: 3px;

              /* overflow: hidden; */
              /* background-color: pink; */
              /* touch-action: none; */
              .content_scoll {
                /* height: 100px; */
                /* width: 2000px; */
                /* background-color: yellow; */
                display: flex;
                flex-wrap: nowrap;
                .area_scroll_holder {
                  width: 25px !important;
                  box-sizing: content-box;
                  padding-left: 50px;
                  color: #ffffff !important;
                }

                li {
                  flex-shrink: 0;
                  margin-left: 10px;
                  width: 325px;
                  height: 293px;
                  opacity: 1;
                  background: #ffffff;
                  border-radius: 10px;
                  overflow: hidden;

                  .scene_title {
                    width: 325px;
                    height: 85px;
                    background: url(../../assets/images/home/i-bg-scene.png);
                    background-size: 100% 100%;
                    box-sizing: border-box;
                    padding-left: 15px;
                    padding-top: 19px;
                    color: #ffffff;

                    .main_title {
                      box-sizing: border-box;
                      margin-bottom: 6px;
                      font-size: 16px;
                      font-family: PingFangSC, PingFangSC-Medium;
                      font-weight: 500;
                      text-align: left;
                      line-height: 22px;
                    }

                    .sub_title {
                      font-size: 14px;
                      font-family: PingFangSC, PingFangSC-Regular;
                      font-weight: 400;
                      text-align: left;
                      color: #ffffff;
                      line-height: 20px;
                    }
                  }

                  .scene_body {
                    box-sizing: border-box;
                    padding-top: 15px;
                    padding-left: 15px;

                    .scene_item {
                      margin-bottom: 10px;

                      .dot {
                        margin-right: 8px;
                        width: 6px;
                        height: 6px;
                        opacity: 1;
                        background: #1c91ff;
                        border-radius: 50%;
                      }

                      .desc {
                        font-size: 14px;
                        font-family: PingFangSC, PingFangSC-Regular;
                        font-weight: 400;
                        text-align: left;
                        color: #666666;
                        line-height: 20px;
                      }
                    }
                  }
                }

                li:first-child {
                  margin-left: 25px;
                }
                li:last-child {
                  width: 14px;
                  background: #f5f9ff;
                }
              }
            }

            .more_scene {
              margin: 25px auto 0;
              width: 331px;
              height: 40px;
              opacity: 1;
              background: #ffffff;
              border-radius: 21px;

              .scene_icon {
                width: 16px;
                height: 16px;
                margin-right: 10px;
              }

              .tips {
                font-size: 14px;
                color: #1c91ff;
              }
            }
          }

          /* 角色收益 */
          .roles {
            .roles_income {
              height: 412px;
              box-sizing: border-box;
              /* background-color: pink; */
              padding-top: 32px;

              .roles_title {
                margin-bottom: 40px;
                font-size: 18px;
                font-family: SourceHanSansCN, SourceHanSansCN-Bold;
                font-weight: 700;
                text-align: center;
                color: #333333;
                line-height: 20px;
              }

              .roles_box {
                width: 305px;
                margin: 0 auto 10px;
                /* background-color: yellow; */
                flex-wrap: wrap;

                .roles_item {
                  align-items: center;
                  margin-bottom: 16px;

                  img {
                    flex-shrink: 0;
                    width: 80px;
                    height: 79px;
                    margin-bottom: 11px;
                  }

                  .role_name {
                    font-size: 12px;
                    color: #333333;
                    line-height: 17px;
                  }
                }
              }

              .roles_btn {
                margin: 0 auto;
                width: 331px;
                height: 40px;
                opacity: 1;
                background: #f5f9ff;
                border-radius: 21px;
                font-size: 14px;
                color: #1c91ff;
              }
            }

            .auto_report {
              box-sizing: border-box;
              padding-top: 20px;
              /* width: 375px; */
              min-height: 416px;
              opacity: 1;
              background: #f5f9ff;

              .report_title {
                margin-bottom: 21px;
                font-size: 18px;
                font-family: SourceHanSansCN, SourceHanSansCN-Bold;
                font-weight: 700;
                text-align: center;
                color: #333333;
                line-height: 20px;
              }

              .report_item {
                margin: 0 auto 10px;
                width: 351px;
                height: 74px;
                opacity: 1;
                box-sizing: border-box;
                padding: 0 10px;
                background: #ffffff;
                border-radius: 10px;

                .i_report {
                  width: 35px;
                  height: 35px;
                  margin-right: 8px;
                }

                .report_item_title {
                  font-size: 15px;
                  font-family: PingFangSC, PingFangSC-Medium;
                  font-weight: 500;
                  text-align: left;
                  color: #333333;
                }

                .i_right_arrow {
                  margin-left: auto;
                  width: 16px;
                  height: 16px;
                }
              }
            }
          }

          /* 信息安全 */
          .info_security {
            height: 268px;
            opacity: 1;
            background: #f5f9ff;
            box-sizing: border-box;
            padding-top: 30px;

            .main_title {
              margin-bottom: 11px;
              font-size: 18px;
              font-family: SourceHanSansCN, SourceHanSansCN-Bold;
              font-weight: 700;
              text-align: center;
              color: #333333;
              line-height: 20px;
            }

            .sub_title {
              margin-bottom: 20px;
              padding: 0 28px;
              box-sizing: border-box;
              font-size: 14px;
              color: #666666;
              text-align: center;
              line-height: 20px;
            }

            .info_security_list {
              box-sizing: border-box;
              padding: 0 33px;

              .info_security_item {
                width: 70px;

                img {
                  margin-bottom: 10px;
                  width: 70px;
                  height: 70px;
                  flex-shrink: 0;
                }

                .name {
                  font-size: 14px;
                  font-family: PingFangSC, PingFangSC-Medium;
                  font-weight: 500;
                  text-align: center;
                  color: #333333;
                  line-height: 20px;
                }
              }
            }
          }
        }

        /* 区域感控相关 */
        /* 区域云服务平台 */
        .area_clould_service {
          height: 542px;
          /* background-color: pink; */
          box-sizing: border-box;
          padding-top: 30px;

          .main_title {
            margin-bottom: 20px;
            font-size: 18px;
            font-family: SourceHanSansCN, SourceHanSansCN-Bold;
            font-weight: 700;
            text-align: center;
            color: #333333;
            line-height: 20px;
          }

          .sub_title {
            margin-bottom: 30px;
            box-sizing: border-box;
            padding: 0 15px;
            font-size: 14px;
            text-align: left;
            color: #333333;
            line-height: 20px;
          }

          .area_service_tab {
            margin: 0 auto;
            width: 109px * 3;
            height: 36px;
            //border: 0.6px solid #999;
            border-radius: 100px;
            background-color: #ffffff;
            overflow: hidden;

            .tab_item {
              height: 100%;
              font-size: 14px;
              color: #666666;
            }

            .tab_item_active {
              background-color: #1c91ff;
              color: #ffffff;
            }
          }

          .area_service_scroll {
            margin-top: 20px;
            height: 300px;
            //width: 375px;
            box-sizing: border-box;
            padding-top: 3px;
            width: 100%;
            overflow: auto;
            -webkit-overflow-scrolling: touch;

            /* overflow: hidden; */
            /* background-color: pink; */
            /* touch-action: none; */
            .content_scoll {
              /* height: 100px; */
              width: 995px;
              /* background-color: yellow; */
              display: flex;
              box-sizing: border-box;
              flex-wrap: nowrap;
              padding: 0 25px;

              li {
                position: relative;
                margin-left: 10px;
                width: 325px;
                /* height: 263px; */
                height: 243px + 28;
                opacity: 1;
                background: #ffffff;
                border-radius: 10px;
                /* overflow: hidden; */

                .scene_title {
                  width: 325px;
                  /* height: 85px; */
                  height: 93px;
                  background: url(../../assets/images/home/i-area-service.png);
                  background-size: 100% 100%;
                  box-sizing: border-box;
                  padding-left: 15px;
                  padding-top: 15px;
                  color: #ffffff;

                  .main_title {
                    box-sizing: border-box;
                    padding: 0 10px;
                    margin-bottom: 6px;
                    font-size: 15px;
                    font-family: PingFangSC, PingFangSC-Medium;
                    font-weight: 500;
                    text-align: left;
                    line-height: 22px;
                    color: #ffffff;
                  }

                  .sub_title_s {
                    box-sizing: border-box;
                    padding-right: 12px;
                    font-size: 14px;
                    font-family: PingFangSC, PingFangSC-Regular;
                    font-weight: 400;
                    text-align: left;
                    color: #ffffff;
                    line-height: 20px;
                  }
                }

                .scene_body {
                  box-sizing: border-box;
                  padding-top: 18px;
                  padding-left: 15px;

                  .scene_item {
                    margin-bottom: 10px;

                    .dot {
                      margin-right: 8px;
                      width: 6px;
                      height: 6px;
                      opacity: 1;
                      background: #1c91ff;
                      border-radius: 50%;
                    }

                    .desc {
                      font-size: 14px;
                      font-family: PingFangSC, PingFangSC-Regular;
                      font-weight: 400;
                      text-align: left;
                      color: #666666;
                      line-height: 20px;
                    }
                  }
                }
              }

              li:first-child {
                margin-left: 0px;
              }
              li:last-child {
                margin-right: 0px;
              }
              #area_scroll_last {
                width: 50px;
                color: #ffffff;
                //background-color: pink;
              }
            }
          }

          .get_try_out {
            position: absolute;
            z-index: 999;
            left: 50%;
            transform: translateX(-50%);
            bottom: -25px;
            width: 225px;
            height: 50px;
            opacity: 1;
            background: linear-gradient(131deg, #fc8a55, #f97482 95%);
            border-radius: 25px;
            box-shadow: 0px 1px 5px 0px #fc875c;
            font-size: 18px;
            font-family: STYuanti, STYuanti-SC;
            font-weight: SC;
            text-align: left;
            color: #ffffff;
          }
        }

        /* 区域数量 */
        /* 区域场景 */
        .areaUseScene {
          box-sizing: border-box;
          padding-top: 31px;
          width: 375px;
          height: 476px;
          opacity: 1;
          background: #ffffff;

          .area_title {
            margin-bottom: 20px;
            font-size: 18px;
            font-family: SourceHanSansCN, SourceHanSansCN-Bold;
            font-weight: 700;
            text-align: center;
            color: #333333;
            line-height: 20px;
          }

          .area_scene_swipe {
            .van-swipe-item {
              height: 345px + 20 + 10 + 12;

              /* background-color: pink; */
              .swipe_box {
                margin: 0 auto;
                width: 327px;
                height: 350px;
                opacity: 1;
                background: #ffffff;
                border-radius: 10px;
                box-shadow: 0px 0px 8px 0px rgba(81, 116, 143, 0.1);
                box-sizing: border-box;
                padding-top: 20px;

                .swipe_box_title {
                  margin-bottom: 4px;
                  font-size: 16px;
                  font-family: PingFangSC, PingFangSC-Medium;
                  font-weight: 500;
                  text-align: center;
                  color: #333333;
                  line-height: 22px;
                }

                .swipe_sub_title {
                  box-sizing: border-box;
                  margin-bottom: 25px;
                  padding: 0 16px;
                  font-size: 14px;
                  text-align: left;
                  color: #666666;
                  line-height: 20px;

                  .detail {
                    color: #26b4ff;
                  }
                }

                .divide {
                  margin-bottom: 13px;
                  width: 327px;
                  height: 13px;
                }

                .big_img {
                  width: 327px;
                  height: 204px;
                }
              }
            }
          }
        }

        /* 自动报告 */
        .auto_report {
          box-sizing: border-box;
          padding-top: 20px;
          /* width: 375px; */
          min-height: 332px;
          opacity: 1;
          background: #f5f9ff;

          .report_title {
            margin-bottom: 21px;
            font-size: 18px;
            font-family: SourceHanSansCN, SourceHanSansCN-Bold;
            font-weight: 700;
            text-align: center;
            color: #333333;
            line-height: 20px;
          }

          .report_item {
            margin: 0 auto 10px;
            width: 351px;
            height: 74px;
            opacity: 1;
            box-sizing: border-box;
            padding: 0 10px;
            background: #ffffff;
            border-radius: 10px;

            .i_report {
              width: 35px;
              height: 35px;
              margin-right: 8px;
            }

            .report_item_title {
              font-size: 15px;
              font-family: PingFangSC, PingFangSC-Medium;
              font-weight: 500;
              text-align: left;
              color: #333333;
            }

            .i_right_arrow {
              margin-left: auto;
              width: 16px;
              height: 16px;
            }
          }
          .holder {
            height: 20px;
          }
        }
      }

      /* 关于我们 */
      .about_us {
        /* height: 276px; */
        height: 226px;
        background: #f2f2f2;

        .card {
          box-sizing: border-box;
          padding-top: 30px;
          padding-bottom: 30px;
          text-align: center;
          width: 100%;
          background-color: #f2f2f2;

          .title {
            margin-bottom: 16px;
            box-sizing: border-box;
            // padding-left: 20px;
            font-size: 13px;
            font-family: PingFangSC, PingFangSC-Medium;
            font-weight: 500;
            // text-align: left;
            color: #333333;
            line-height: 18px;
          }

          .body {
            .card_item {
              margin-bottom: 20px;
              font-size: 13px;
              // text-align: left;
              color: #666666;
              line-height: 18px;

              .phone {
                padding-left: 10px;
                color: #1c91ff;
              }
            }

            .card_row {
              margin-bottom: 11px;

              .card_row_item {
                font-size: 13px;
                // text-align: left;
                color: #666666;
                line-height: 18px;

                img {
                  width: 18px;
                  height: 19px;
                }
              }
              .link_active {
                color: #1c91ff;
              }
            }

            .card_row_item_pad {
              box-sizing: border-box;
              // padding-left: 20px;
            }
          }

          .body_pad {
            box-sizing: border-box;
            // padding-left: 20px;
          }
        }

        .card_1 {
          padding-top: 35px;
        }

        .card_2 {
          padding-top: 5px;
        }
        .card_row_item_link {
          margin-bottom: 10px;
        }
      }
    }
  }

  /* 用户之声 */
  .user_voice {
    /* width: 375px; */
    height: 519px;
    box-sizing: border-box;
    padding-top: 30px;
    opacity: 1;
    background: #ffffff;

    /* background-color: pink; */
    .user_title {
      margin-bottom: 11px;
      box-sizing: border-box;
      font-size: 18px;
      font-family: SourceHanSansCN, SourceHanSansCN-Bold;
      font-weight: 700;
      text-align: center;
      color: #333333;
      line-height: 20px;
    }

    .user_sub_title {
      margin-bottom: 34px;
      font-family: SourceHanSansCN, SourceHanSansCN-Regular;
      font-weight: 400;
      text-align: center;
      color: #333333;
      line-height: 20px;
    }

    .hospital_img_box {
      box-sizing: border-box;
      padding: 0 12px;
      flex-wrap: wrap;
      margin-bottom: 10px;

      img {
        margin-bottom: 11px;
        width: 170px;
        height: 39px;
        flex-shrink: 0;
        flex-wrap: wrap;
      }
    }

    .user_voice_scroll {
      /* width: 375px; */
      height: 160px;
      box-sizing: border-box;
      padding-top: 2px;
      width: 100%;
      overflow: auto;
      -webkit-overflow-scrolling: touch;
      /* overflow: hidden; */
      /* touch-action: none; */
      /* overflow: hidden; */
      .content_scoll {
        /* width: 2000px; */
        display: flex;
        flex-wrap: nowrap;

        /* overflow: hidden; */
        li {
          overflow: hidden;
          position: relative;
          flex-shrink: 0;
          margin-left: 10px;
          width: 325px;
          height: 156px;
          box-sizing: border-box;
          padding-top: 15px;
          border-radius: 10px;
          /* background-color: rgba(0,0,0,0.2); */
          /* background: url(../../assets/images/home/i-user-voiec-hospital.png); */
          /* background: url(https://demo.gkgzj.com/incontrol-fileserver/file/download/016f8fd5-19f3-4248-aabf-d5a15a13f36c); */
          background-size: 100% 100%;
          .bg_shadow {
            position: absolute;
            left: 0;
            bottom: 0;
            right: 0;
            top: 0;
            box-sizing: border-box;
            padding-top: 15px;
            /* background: rgba(0,0,0,0.3); */
          }
          .main_title {
            margin-bottom: 20px;
            font-size: 18px;
            font-family: PingFangSC, PingFangSC-Medium;
            font-weight: 500;
            text-align: center;
            color: #ffffff;
            line-height: 25px;
          }

          .sub_title {
            box-sizing: border-box;
            padding: 0 12px;
            font-size: 14px;
            font-family: PingFangSC, PingFangSC-Regular;
            font-weight: 400;
            text-align: left;
            color: #ffffff;
            line-height: 20px;
          }

          .detail_btn {
            position: absolute;
            right: 12px;
            bottom: 15px;
            width: 98px;
            height: 30px;
            opacity: 1;
            background: rgba(0, 0, 0, 0.5);
            border-radius: 15px;

            div {
              font-size: 14px;
              color: #ffffff;
            }

            img {
              margin-left: 1px;
              width: 18px;
              height: 17px;
            }
          }
        }

        li:first-child {
          margin-left: 25px;
        }
        li:last-child {
          width: 14px;
        }
      }
    }

    .more_case {
      margin: 25px auto 0;
      width: 332px;
      height: 40px;
      opacity: 1;
      background: #f5f9ff;
      border-radius: 21px;
      font-size: 14px;
      color: #1c91ff;
    }
  }

  .share-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 12020;
    background-color: rgba(0, 0, 0, 0.6);
    background-image: url(../../assets/images/wechat.png);
    background-repeat: no-repeat;
    background-size: contain;
  }

  .popup_box {
    width: 330px;
    //height: 395px + 96px;
    opacity: 1;
    //background: transparent;
    //background-color:transparent !important;;
    //border-radius: 10px;
    background-color: rgba(0, 0, 0, 0.7);
    border-width: 0 !important;
    border-color: rgba(0, 0, 0, 0.7);
    .i-close {
      margin-left: auto;
      width: 28px;
      height: 28px;
      margin-bottom: 20px;
      //transform: translateY(-20px);
      //margin-top: -20px;
      //position: ;
    }
    .popup_inner {
      width: 330px;
      min-height: 395px;
      opacity: 1;
      padding-bottom: 20px;

      background: #ffffff;
      //background-color: yellow;
      border-radius: 10px;
      .popup_header {
        width: 330px;
        overflow: hidden;
        margin-top: 40px;
        box-sizing: border-box;
        //padding-left: 26px;
        height: 80px;
        //background-color: gray;
        .role_pic {
          margin-right: 35px;
          width: 80px;
          height: 79px;
        }
        .role_pic:first-child {
          margin-left: 26px;
        }
        .role_min {
          flex-shrink: 0;
          width: 50px;
          height: 49px;
        }
      }
      .popup_title {
        margin-top: 11px;
        margin-bottom: 15px;
        box-sizing: border-box;
        padding-left: 22px;
        font-size: 16px;
        font-family: SourceHanSansCN, SourceHanSansCN-Bold;
        font-weight: 700;
        text-align: left;
        color: #333333;
      }
      .popup_body {
        box-sizing: border-box;
        padding: 20px 0;
        margin: 0 auto;
        width: 300px;
        height: 320px;
        opacity: 1;
        background: #f5f9ff;
        border-radius: 10px;

        .popup_scroll_container {
          width: 100%;
          height: 100%;
          overflow: scroll;
          //background-color: pink;
          ul {
            overflow: hidden;
            li {
              box-sizing: border-box;
              padding-right: 10px;
            }
          }
        }

        .scene_item {
          box-sizing: border-box;
          padding-left: 15px;
          margin-bottom: 10px;

          .dot {
            flex-shrink: 0;
            margin-right: 8px;
            width: 6px;
            height: 6px;
            opacity: 1;
            background: #1c91ff;
            border-radius: 50%;
          }

          .desc {
            font-size: 14px;
            font-family: PingFangSC, PingFangSC-Regular;
            font-weight: 400;
            text-align: left;
            color: #666666;
            line-height: 20px;
          }
        }
      }
    }
    //position: relative;
  }

  .v-top {
    position: fixed;
    right: 32px;
    bottom: 128px;
    flex-shrink: 0;
    z-index: 1000;
    width: 42px;
    height: 42px;
    opacity: 1;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 50%;
    font-size: 12px;
    color: #ffffff;

    img {
      width: 20px;
      height: 11px;
      margin-bottom: 2px;
    }
  }

  .footer {
    position: fixed;
    z-index: 1001;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .case_mask {
    position: absolute;
    /* z-index: 1; */
    box-sizing: border-box;
    padding-top: 15px;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    width: 325px;
    background: linear-gradient(
      180deg,
      #1c91ff,
      rgba(28, 145, 255, 0.7) 24%,
      rgba(0, 0, 0, 0.35)
    );
  }

  .case_mask_title1 {
    box-sizing: border-box;
    padding-left: 8px;
    padding-right: 13px;
  }

  /deep/ .van-tab {
    font-size: 16px;
  }
  .statistics_blue {
    background: #f5f9ff !important;
  }
  /deep/ .van-popup__close-icon--top-right {
    top: 0.22667rem;
    right: 0.12667rem;
  }
  /deep/ .van-popup__close-icon--top-right {
    top: 0.22667rem;
    right: 0.32667rem;
  }
  ///deep/.popup-background-color {
  //  //background-color: pink;
  //  //line-height: 0.8rem;
  //}
  #about_title {
    font-size: 18px;
    margin-bottom: 30px;
  }
  #about_desc {
    font-size: 16px;
  }
}
</style>
